import { FC } from 'react';
import Modal from 'react-modal';

import { PsychicCtaButtons } from 'entities/PsychicCtaButton';
import styles from 'components/Sections/ExponeaPsychicProfile/ExponeaPsychicProfile.module.scss';
import { getStatus } from 'lib/psychic.service';
import { Status } from 'constants/enums';

import Queue from './Queue';
import EstimatedTime from './EstimatedTime';
import type { IStickyInteraction } from './config/declarations';

const StickyInteraction: FC<IStickyInteraction> = ({
  isMobile,
  bootStatus,
  cta,
  psychic,
  psychicFrame,
}) => {
  if (!isMobile) {
    return (
      <PsychicCtaButtons
        bootStatus={bootStatus}
        chatButton={cta.chatButton}
        talkButton={cta.talkButton}
        callbackButton={cta.callbackButton}
        messageButton={cta.messageButton}
        inQueueButton={cta.inQueueButton}
        psychic={psychic}
        shape="Oval"
        psychicFrame={psychicFrame}
        className={styles.interaction}
      />
    );
  }

  const textsArray = psychicFrame.estimatedWaiting?.split('-') || [];
  const uponText = textsArray[2] || '';
  const { chatStatus, phoneStatus } = psychic;
  const status = getStatus({ chatStatus, phoneStatus });
  const isBusyOrQueuedOffline = (status === Status.OFFLINE && psychic.peopleInQueue)
  || (status === Status.ON_BREAK && psychic.peopleInQueue)
  || status === Status.BUSY;

  return (
    <Modal
      isOpen
      className={styles.sticky}
      overlayClassName={styles.stickyOverlay}
    >
      {psychic.peopleInQueue > 0 && (
        <div className={styles.info}>
          <Queue
            queue={psychicFrame.queue}
            peopleInQueue={psychic.peopleInQueue}
            isModal
          />
          <div className={styles.divider} />
          <div className={styles.stickyUpon}>
            <EstimatedTime
              isShortText
              texts={psychicFrame.estimatedWaiting}
              timeUnit={psychicFrame.ratePerMinute}
              estimatedTime={psychic.estimatedWaitTime}
            />
            {
              !isBusyOrQueuedOffline
              && <div className={styles.stickyUponText}>{uponText}</div>
            }
          </div>
        </div>
      )}
      <PsychicCtaButtons
        bootStatus={bootStatus}
        chatButton={cta.chatButton}
        talkButton={cta.talkButton}
        callbackButton={cta.callbackButton}
        messageButton={cta.messageButton}
        inQueueButton={cta.inQueueButton}
        psychic={psychic}
        shape="Oval"
        psychicFrame={psychicFrame}
        className={styles.interaction}
      />
    </Modal>
  );
};

export default StickyInteraction;
